// src/api/auth.js
import API from "../axiosConfig";

export const getTypeInfraction = async () => {
  try {
    const response = await API.get("/type-infractions");
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};

export const createTypeInfraction = async (payload) => {
  try {
    const response = await API.post("/type-infractions", { ...payload });
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};

export const updateTypeInfraction = async (id, name, name_ar, amount, category, repeated_amount) => {
  try {
    const response = await API.put(`/type-infractions/${id}`, {
      name,
      amount,
      name_ar,
      category,
      repeated_amount,
    });
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};
